import { Button, Stack } from "@mui/material";
import { useMobileBreakpoint } from "@ob/theme";
import { forwardRef, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { HButton, HButtonProps } from "../../components";

type TProps = {
  onBack?: () => void;
  onForward?: HButtonProps["onClick"]; // () => void;
  backDisabled?: boolean;
  forwardDisabled?: boolean;
  hideBack?: boolean;
  hideForward?: boolean;
  loading?: boolean;
  previousLabel?: string;
  nextLabel?: string;
};

export const StepButtons = forwardRef<HTMLButtonElement, TProps>(
  (props, submitRef) => {
    const {
      formState: { errors, submitCount },
    } = useFormContext();
    const {
      onBack,
      onForward,
      backDisabled,
      forwardDisabled,
      hideBack,
      hideForward,
      loading,
      previousLabel = "Indietro",
      nextLabel = "Avanti",
    } = props;
    const { isMobile } = useMobileBreakpoint();
    const errorsList = Object.keys(errors).filter(error => !!error);
    const formNotValid = submitCount > 0 && errorsList.length > 0;
    if (formNotValid) {
      console.log("*****: errorsList", errorsList);
    }
    const justifyContent = useMemo(() => {
      if (hideBack || hideForward || isMobile) return "center";
      return "space-between";
    }, [hideBack, hideForward, isMobile]);

    return (
      <Stack
        className="button-container sticky-bottom"
        direction={isMobile ? "column" : "row"}
        justifyContent={justifyContent}
        alignItems="center"
        gap={isMobile ? 0 : 6}
        sx={{
          flexGrow: 0,
          flexShrink: 0,
          px: { xs: 5, sm: 6, md: 3 },
          pt: { xs: 5, sm: 3, md: 3 },
        }}
      >
        {!isMobile && !hideBack && (
          <Button
            fullWidth
            variant="secondary"
            sx={{ maxWidth: 294 }}
            disabled={backDisabled}
            onClick={onBack}
          >
            {previousLabel}
          </Button>
        )}
        {!hideForward && (
          <HButton
            variant="primary"
            type="submit"
            fullWidth
            sx={{ maxWidth: { xs: "100%", sm: 294 } }}
            ref={submitRef}
            disabled={forwardDisabled}
            onClick={onForward}
            loading={loading}
          >
            {nextLabel}
          </HButton>
        )}
      </Stack>
    );
  },
);
